import Pagenation from "../../../ecommerce/globalcomponents/pagenation/Pagenation";

const PlayGames = () => {
  return (
    <>
      <div className="display-max main-page px-3">
        <div className="row d-flex w-auto justify-content-center px-2 ms-1">
          <div className="card shadow-card border-radius-lg card-body mt-2">
            <div className=" d-flex justify-content-between align-items-center">
              <div>
                <h2 className="source-serif-4 text-normal text-dark px-3">
                  Play Games
                </h2>
              </div>
            </div>
            <div className="row align-items-center mb-2 container-fluid mt-2">
              <div className="d-flex gap-2 align-items-center mb-2">
                <div className=" dropdown">
                  <div
                    className="input-group input-group-outline "
                    id="dropdownLastEntries"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="10 Entries"
                    />
                    <span className="input-group-text pe-2">
                      <i className="ri-arrow-down-s-line fs-5 opacity-6"></i>
                    </span>
                    <div
                      className="dropdown-menu dropdown-menu-three dropdown-menu-animation w-100 nav-menu p-2 px-2 border-radius-md"
                      aria-labelledby="dropdownLastEntries"
                    >
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 25 Entries
                          </b>
                        </a>
                      </div>
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 50 Entries
                          </b>
                        </a>
                      </div>
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 75 Entries
                          </b>
                        </a>
                      </div>
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 100 Entries
                          </b>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className=" d-flex justify-content-start align-items-center gap-2 px-2">
                <div className=" w-100">
                  <div className="card border border-radius-lg">
                    <div className="card-header position-relative z-index-2 bg-transparent">
                      <a href="#" className="d-block blur-shadow-image">
                        <img
                          src="https://images.unsplash.com/photo-1527547637224-a93d42c7b332?q=80&w=1200&auto=format&fit=crop"
                          alt="img-blur-shadow"
                          className="img-fluid shadow border-radius-lg"
                        />
                      </a>
                    </div>
                    <div className="px-2">
                      <h5 className="font-weight-bold">
                        <a href="#">Cozy 5 Stars Apartment</a>
                      </h5>
                      <p className="mb-0 text-sm">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Laudantium ex deleniti.
                      </p>
                      <div className=" mt-3 mb-2 text-center">
                        <button className=" btn btn-dark btn-md w-70">
                          Play
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" w-100">
                  <div className="card border border-radius-lg">
                    <div className="card-header position-relative z-index-2 bg-transparent">
                      <a href="#" className="d-block blur-shadow-image">
                        <img
                          src="https://images.unsplash.com/photo-1622485480253-8abe11c61751?q=80&w=1200&auto=format&fit=crop"
                          alt="img-blur-shadow"
                          className="img-fluid shadow border-radius-lg"
                        />
                      </a>
                    </div>
                    <div className="px-2">
                      <h5 className="font-weight-bold">
                        <a href="#">Cozy 5 Stars Apartment</a>
                      </h5>
                      <p className="mb-0 text-sm">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Laudantium ex deleniti.
                      </p>
                      <div className=" mt-3 mb-2 text-center">
                        <button className=" btn btn-dark btn-md w-70">
                          Play
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" w-100">
                  <div className="card border-radius-lg border">
                    <div className="card-header position-relative z-index-2 bg-transparent">
                      <a href="#" className="d-block blur-shadow-image">
                        <img
                          src="https://images.unsplash.com/photo-1578271887552-5ac3a72752bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80"
                          alt="img-blur-shadow"
                          className="img-fluid shadow border-radius-lg"
                        />
                      </a>
                    </div>
                    <div className="px-2">
                      <h5 className="font-weight-bold">
                        <a href="#">Cozy 5 Stars Apartment</a>
                      </h5>
                      <p className="mb-0 text-sm">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Laudantium ex deleniti.
                      </p>
                      <div className=" mt-3 mb-2 text-center">
                        <button className=" btn btn-dark btn-md w-70">
                          Play
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" w-100">
                  <div className="card border border-radius-lg">
                    <div className="card-header position-relative z-index-2 bg-transparent">
                      <a href="#" className="d-block blur-shadow-image">
                        <img
                          src="https://images.unsplash.com/photo-1527246201253-ce566026066e?q=80&w=1200&auto=format&fit=crop"
                          alt="img-blur-shadow"
                          className="img-fluid shadow border-radius-lg"
                        />
                      </a>
                    </div>
                    <div className="px-2">
                      <h5 className="font-weight-bold">
                        <a href="#">Cozy 5 Stars Apartment</a>
                      </h5>
                      <p className="mb-0 text-sm">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Laudantium ex deleniti.
                      </p>
                      <div className=" mt-3 mb-2 text-center">
                        <button className=" btn btn-dark btn-md w-70">
                          Play
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className=" mt-3 mb-3">
              <Pagenation />
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob pt-3 pb-5">
        <div className=" px-2">
          <div className=" px-2 card border-radius-lg ">
            <div className=" d-flex justify-content-between align-items-center mt-4">
              <div>
                <div className="text-start mb-2">
                  <h3 className="source-serif-4 fw-normal text-dark px-2">
                    Play Games
                  </h3>
                </div>
              </div>
              <div>
                <div className=" dropdown">
                  <div
                    className="input-group input-group-outline "
                    id="dropdownCategories"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="Last 10 Entries"
                    />
                    <span className="input-group-text pe-2">
                      <i className="ri-arrow-down-s-line fs-5 opacity-6"></i>
                    </span>
                    <div
                      className="dropdown-menu dropdown-menu-animation w-100 dropdown-md nav-menu p-2 px-2 border-radius-md"
                      aria-labelledby="dropdownCategories"
                    >
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 25 Entries
                          </b>
                        </a>
                      </div>
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 50 Entries
                          </b>
                        </a>
                      </div>
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 75 Entries
                          </b>
                        </a>
                      </div>
                      <div className="lh-lg mt-2 dropdown-item border-radius-md mb-2 p-1">
                        <a className="" href=".">
                          <b className="p-2 fw-normal text-black">
                            Last 100 Entries
                          </b>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className=" px-2 p-2 mb-2">
              <div className=" w-100 mb-3">
                <div className="card border border-radius-lg">
                  <div className="card-header position-relative z-index-2 bg-transparent">
                    <div className="d-block blur-shadow-image">
                      <img
                        src="https://images.unsplash.com/photo-1527547637224-a93d42c7b332?q=80&w=1200&auto=format&fit=crop"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </div>
                  </div>
                  <div className="px-2">
                    <h5 className="font-weight-bold">
                      <a href="#">Cozy 5 Stars Apartment</a>
                    </h5>
                    <p className="mb-0 text-sm">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Laudantium ex deleniti.
                    </p>
                    <div className=" mt-3 mb-3 text-center">
                      <button className=" btn btn-dark btn-md w-50">
                        Play
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" w-100 mb-3">
                <div className="card border border-radius-lg">
                  <div className="card-header position-relative z-index-2 bg-transparent">
                    <div className="d-block blur-shadow-image">
                      <img
                        src="https://images.unsplash.com/photo-1622485480253-8abe11c61751?q=80&w=1200&auto=format&fit=crop"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </div>
                  </div>
                  <div className="px-2">
                    <h5 className="font-weight-bold">
                      <a href="#">Cozy 5 Stars Apartment</a>
                    </h5>
                    <p className="mb-0 text-sm">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Laudantium ex deleniti.
                    </p>
                    <div className=" mt-3 mb-3 text-center">
                      <button className=" btn btn-dark btn-md w-50">
                        Play
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" w-100 mb-3">
                <div className="card border-radius-lg border">
                  <div className="card-header position-relative z-index-2 bg-transparent">
                    <div className="d-block blur-shadow-image">
                      <img
                        src="https://images.unsplash.com/photo-1578271887552-5ac3a72752bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </div>
                  </div>
                  <div className="px-2">
                    <h5 className="font-weight-bold">
                      <a href="#">Cozy 5 Stars Apartment</a>
                    </h5>
                    <p className="mb-0 text-sm">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Laudantium ex deleniti.
                    </p>
                    <div className=" mt-3 mb-3 text-center">
                      <button className=" btn btn-dark btn-md w-50">
                        Play
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" w-100 mb-3">
                <div className="card border border-radius-lg">
                  <div className="card-header position-relative z-index-2 bg-transparent">
                    <div className="d-block blur-shadow-image">
                      <img
                        src="https://images.unsplash.com/photo-1527246201253-ce566026066e?q=80&w=1200&auto=format&fit=crop"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </div>
                  </div>
                  <div className="px-2">
                    <h5 className="font-weight-bold">
                      <a href="#">Cozy 5 Stars Apartment</a>
                    </h5>
                    <p className="mb-0 text-sm">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Laudantium ex deleniti.
                    </p>
                    <div className=" mt-3 mb-3 text-center">
                      <button className=" btn btn-dark btn-md w-50">
                        Play
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className=" mt-3 mb-3">
              <Pagenation />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlayGames;
